import React from 'react'
import { observer } from 'mobx-react'
import BrokerPicker from './BrokerPicker'
import BrokerLogin from './BrokerLogin'
import BrokerSyncingStatus from './BrokerSyncingStatus'
import MultiFactorAuth from './MultiFactorAuth'
import WorkingIndicator from './WorkingIndicator'

import './styles.sass'

const QuovoProvider = ({ provider }) => {
  // I know this isn't very functional, but it was the easiest way
  // to get the view swapping done without over-arching things.
  let View = BrokerPicker
  if (provider.fetchingBrokerages) {
    View = LoadingBrokerages
  } else {
    // When we have selected a brokerage,
    // show the broker login.
    if (provider.selectedBrokerage) {
      View = BrokerLogin
    }

    if (provider.multiFactorAuthState) {
      // If there's a multi-factor auth challenge present,
      // show that.
      if (provider.multiFactorAuthState.challenge) {
        View = MultiFactorAuthView
      } else {
        // Cheating to reuse the syncing view while loading challenges. Hehe.
        View = BrokerSyncingStatus
      }
    }

    // If we're either syncing, or done syncing..
    if (provider.syncing || provider.syncProgress === 100) {
      View = BrokerSyncingStatus
    }
  }

  return (
    <div className="quovo-provider">
      <View provider={provider} />
    </div>
  )
}

export default observer(QuovoProvider)

// Proxy this so rerendering does not trigger errors when we nullify the state.
const MultiFactorAuthView = ({ provider }) => <MultiFactorAuth state={provider.multiFactorAuthState} />

const LoadingBrokerages = () => <WorkingIndicator>Loading brokerages, please wait</WorkingIndicator>



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/ProviderView.jsx